import { WordObject } from '../interfaces/proofreaderActivities'

export const BOLD_BEGINS = '(bolded text begins here)'
export const BOLD_ENDS = '(bolded text ends here)'

export const isEdited = (word: Pick<WordObject, 'currentText' | 'originalText'>) => word.currentText.trim() !== word.originalText
